Service = App.loadClass 'core::Angular/Service'

class exports.ValidationService extends Service
    constructor: (@state, @fields, @zones_service, @pgis, @layers) ->
        @disabled = {
            next: false
            required: false
            back: false
        }
        @text = {
            next: 'Next'
            back: 'Back'
            required: 'Required *'
        }
        @validGeometryTypes = ['Polygon', 'MultiPolygon']
        @process_mode = 'zone-add'
        @wait_before_next_step = false
        @setFieldsData()

    setZones: (@zones) =>
        undefined

    setText: (key, text) =>
        @text[key] = text
        @mainscope.text = @text

    setDisabled: (key, text) =>
        @disabled[key] = text
        @mainscope.disabled = @disabled

    setHideBack: (bool) =>
        @mainscope.hide_back = bool
    setHideNext: (bool) =>
        @mainscope.hide_next = bool

    setFieldsData: () =>
        @fields.all().then (result) =>
            @fields_data = result.data.data

    setProcessMode: () =>
        @process_mode = @fields.getProcessMode()

    setMainScope: (@mainscope) =>
        # handle boundary
        @checkBoundary()
        @setFieldData(@mainscope.field_data) if @mainscope?.field_data?

    setStepScope: (stepscope, initialize = true) =>
        # cleanup previous step scope first
        @stepscope?.cleanup?()
        @stepscope = stepscope
        # disable button
        @initializeStep() if initialize

    initializeStep: () =>
        # disable the next button at the start of required steps
        @validate()

    cleanup: () =>
        @settings = null
        @process_mode = 'zone-add'
        @setMainScope(null)
        @setStepScope(null)
        @fields_data = null
        @setFieldsData()
        # clear all other services and controllers
        @mainscope?.$destroy?()
        @stepscope?.$destroy?()
        @fields?.cleanup?()
        @zones_service?.cleanup?()
        @pgis?.cleanup?()

    validate: (param) =>
        # only validate required steps
        if @stepscope?
            # call step specific validate function
            if @stepscope.validate(param) is true
                # if it passes then enable the next button
                @mainscope?.disabled.next = false
            else
                # if validation fails then disable the next button
                @mainscope?.disabled.next = true

    wentBack: () =>
        zones = @getFieldData().zones
        if zones?.zones?
            for z in zones.zones
                z.visible.clearLayers()

    checkBoundary: () =>
        undefined

    setModeSettings: (@settings) =>
        undefined

    setupByMode: () =>
        if @settings.process_mode in ['zone-add', 'irrigation-add']
            @fields.setFieldsId(@settings.fid)
            @fields.setYear(@settings.year)
        if @settings.process_mode is 'zone-edit'
            @fields.setFieldsId(@settings.fid)
            @fields.setYear(@settings.year)
            @fields.setLayersId(@settings.layers_id)
            @fields.setLayerTitle(@settings.layers_title)

        @fields.setProcessMode(@settings.process_mode)

    setFieldData: (@field_data) =>
        undefined

    getFieldData: () ->
        return @field_data

    setBackButtonDisable: (field_data, mode) =>
        if field_data.process_mode is mode
            @mainscope.disabled.back = true
        else
            @mainscope.disabled.back = false

    clearLayers: () ->
        @layers.destroyAllSubHandlers()
        App.layer_store.delete(@mainscope?.field_data?.id)
        @pgis.removeAddedLayers()
        @pgis.clearBoundaryLayer()

    # check this at the start of each step to prevent errors when refreshing or navigating directly to a step
    canContinue: () ->
        if @field_data?
            return true
        else
            @state.go 'grower.fields'
            return false

    convertGeometryCollection: (collection) ->
        converted = []

        for geometry in collection.geometry.geometries when geometry.type in @validGeometryTypes
            converted.push { type: "Feature", properties: {}, geometry: geometry }

        return converted

